import { render, staticRenderFns } from "./SelectOptsWrapper.vue?vue&type=template&id=6c1059ca&"
import script from "./SelectOptsWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectOptsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1059ca')) {
      api.createRecord('6c1059ca', component.options)
    } else {
      api.reload('6c1059ca', component.options)
    }
    module.hot.accept("./SelectOptsWrapper.vue?vue&type=template&id=6c1059ca&", function () {
      api.rerender('6c1059ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SelectOptsWrapper.vue"
export default component.exports